<div class="wizard-header medium">{{html-safe (i18n this.header)}}</div>

<div class="link-list">
  {{#if this.anyLinks}}
    {{#each this.links as |link|}}
      <div data-id={{link.id}}>
        {{d-button
          action=(action "change")
          actionParam=link.id
          translatedLabel=link.label
          class=link.classes
        }}
        {{#unless link.first}}
          {{d-button
            action=(action "back")
            actionParam=link
            icon="arrow-left"
            class="back"
          }}
        {{/unless}}
        {{#unless link.last}}
          {{d-button
            action=(action "forward")
            actionParam=link
            icon="arrow-right"
            class="forward"
          }}
        {{/unless}}
        {{d-button
          action=(action "remove")
          actionParam=link.id
          icon="xmark"
          class="remove"
        }}
      </div>
    {{/each}}
  {{/if}}
  {{d-button action=(action "add") label="admin.wizard.add" icon="plus"}}
</div>